module.exports = __webpack_public_path__ + "img/picture_news_03.de36c220.png";